/*!
*                                        .sdNMMMNmy
*                                       :NMMMMMMMMMM
*                            .+hmNNdysohMMMMMMMMMMMMN-
*                         .+dMMMMMMMMMMMMMMMMMMMMMMMMN+
*               `-:/+osydNMMMMMMMMMMMMMMMMMMMMMMMMMMMMMh.    `
*         `:oydNMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMm-   o/
*      `+dMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMm`  yd         `
*     +NMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM/  dN`       -y
*   `yMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMNmMMMM+ +Ms        sN
*   yMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMmo:mMNMmmMMMydm+        .MM
*  :MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM:  .ooMMhNMN:.          yMd
*  yMdNMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM:     +MMddd          .yMM:
*  ms+MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMN+      -dmMNh+::---:/ohMMm:
*  M/`dMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMN.       `NNdmdmNMMMMNmdho:
*  Ns .mMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMm-         oMMMo   ``
*  -+  yMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM/           `mMMd
*     .NMMmNMMMMMMMMMMMMMMMMMNMMMMMMMMMMMy            .mMMo
*     hMMMdhMMMMMMMNMMMMMMMmhyyhMMMMMMMMMMs            .dMMh-
*    sMMMMsNMMMMMMd+syyso/ymMMMm+yMMMMMMMMMh`            /dMMms+/+o`
*   /MMMMMoMMMMMMMo       dMMMMM+ .yMMMMMMMMh              .+ydmNNh
*   mMMMMM+MMMMMMMs       oMMMMMs   :NMMMMMMM`
*   NMMMMM:NMMMMMMs       .NMMMMN`   -NMMMMMm
*   NMMMMMsoMMMMMM:       `NMMMMMd`   sMMMMMs
*   :osyso.`NMMMMMo       `+yhhys:    :MMMMMm-
*          .NMMMMMMd-                 /MMMMMMM:
*          `ohmNMMNh.                 `+yhdmds.
*
*  Solution by Little Giant
*
*/
import 'babel-polyfill';
import 'isomorphic-fetch';

// React
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import Reducer from './react/reducer';
import App from './react/app';

// Components
import MobNav from './components/mobile-nav';
import Notifications from './components/notifications';
import Share from './components/share';
import Forms from './components/forms';
import Header from './components/header';
import Carousels from './components/carousels';
import Scroll from './components/scroll';
import ImageGallery from './components/image-gallery';
import CreditApplication from './components/credit-application';
import TabbedSections from './components/tabbed-sections';
import Accordion from './components/accordion';
import IplexModal from './components/modal';
import NewsFilters from './components/news-filters';
import Search from './components/search';
import { jsx as _jsx } from "react/jsx-runtime";
document.addEventListener('DOMContentLoaded', function () {
  document.components = [new MobNav(), new Share(), new Forms(), new Header(), new Carousels(), new Scroll(), new ImageGallery(), new CreditApplication(), new TabbedSections(), new Accordion(), new IplexModal(), new NewsFilters(), new Notifications(), new Search()];

  // --------------------------------------------------
  // React App
  // --------------------------------------------------
  var store = createStore(Reducer);
  var pageTemplate = document.body.dataset.pageTemplate;
  store.dispatch({
    type: 'SET_PAGE_TEMPLATE',
    pageTemplate: pageTemplate
  });
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(App, {
      pageTemplate: document.body.dataset.pageTemplate
    })
  }), document.getElementById('js-react-app'));
});